import React from 'react';

const BasicInput = (props) => {
    const {
        name,
        onChange        = () => {},
        disabled        = false,
        type            = null,
        value           = null,
        required        = false,
        autocomplete    = null,
        autofocus       = null,
        error           = null,
        min             = null,
        max             = null,
        step            = null,
    } = props;

    return (
        <input
            id={name}
            name={name}
            type={!!type ? type : "text"}
            className={!error ? "form-control shadow-none" : "form-control shadow-none is-invalid"}
            value={value !== null && typeof value !== 'undefined' ? value : ""}
            min={min}
            max={max}
            step={step}
            required={required}
            autoComplete={!!autocomplete ? autocomplete : null}
            autoFocus={autofocus}
            disabled={disabled}
            onChange={(event) => onChange(event.target.value)}
        />
    )
}

export default BasicInput;
